import {
  Button,
  Cascader,
  Checkbox,
  Col,
  Form,
  Input,
  Popover,
  Radio,
  Row,
  Select,
  Space,
} from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import { SearchOutlined, CaretDownFilled, QuestionCircleTwoTone } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import {
  pageDurgsystem,
  selectDurgsystemData,
} from '../durgsystem/durgsystemSlice'
import { storePageParams } from '../../services/storesearch'
import { DateSelect, RecentTimes, StoreSearchRecentTimes } from '../../compnents/form/DateSelect'
import {
  BillingCategoryName,
  InvoiceBillingCategories,
} from '../../models/billingCategory'
import { setCurrent } from './storesearchSlice'
import styles from './Storesearch.module.css'
import { FilterIconOutlined, PrintOutlined } from '../../compnents/icons/Icons'
import { useLocation } from 'react-router-dom'
import { stringTrim } from '../../utils/StringUtils'
import { ThemeContext } from '../../theme/ThemeContext'
import { getMaterialsName, Materiales } from '../../models/commodity'
import { getCommonCodeCompletionsAsync } from '../completion/completionSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import { CommonCodeCategory } from '../../models/commoncode'
import { RootDispatch } from '../../app/store'
import { selectTenantCategory } from '../../app/applicationSlice'
import moment from 'moment'
import { DateTimeFormatSimple, DateTimeFormatSimpleOnly } from '../../models/datetime'
import { FilterColumn } from '../../compnents/filterForm/filterForm'
const { Option } = Select

export const useCascaderDropdownRender = (
  treeData: any[],
  getValue: () => any[][],
  setValue: (v: any[][]) => void,
  onChange: () => void,
) => {
  return React.useCallback((menus: React.ReactNode) => {
    const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
      const target = e.target as HTMLElement
      const menuItem = target.closest('.ant-cascader-menu-item') as HTMLElement | null
      if (!menuItem) return
      const menu = menuItem.closest('.ant-cascader-menu') as HTMLElement | null
      if (!menu) return
      const menus = menu.parentElement?.querySelectorAll('.ant-cascader-menu')
      const menuIndex = menus ? Array.from(menus).indexOf(menu) : -1
      if (menuIndex !== 0) return
      if (target.closest('.ant-checkbox-wrapper')) return

      const labelEl = menuItem.querySelector('.ant-cascader-menu-item-content')
      if (!labelEl || !labelEl.contains(target)) return
      const labelText = labelEl.textContent?.trim()
      const topNode = treeData.find((v) => v.label === labelText)
      if (!topNode) return

      const currentValue: any[][] = getValue() || []
      const topVal = topNode.value

      const children: any[] = topNode.children || []
      if (children.length === 0) return

      const hasTop = currentValue.some((p) => p.length === 1 && p[0] === topVal)
      const allChildPaths = children.map((c: any) => [topVal, c.value])
      const allChildSelected = allChildPaths.every((cp) =>
        currentValue.some((p) => p[0] === cp[0] && p[1] === cp[1])
      )
      const isFullySelected = hasTop && allChildSelected

      let newValue: any[][]
      if (isFullySelected) {
        newValue = currentValue.filter((p) => p[0] !== topVal)
      } else {
        const withoutTop = currentValue.filter((p) => p[0] !== topVal)
        newValue = [...withoutTop, [topVal], ...allChildPaths]
      }

      setValue(newValue)
      onChange()
      // 阻止冒泡，避免 Cascader 原生事件再次处理
      e.stopPropagation()
    }
    return <div onClick={handleClick}>{menus}</div>
  }, [treeData])
}

const normalizeMaterialsCategory = (value: any) => {
  if (!value) return []
  if (Array.isArray(value) && value.length === 0) return []
  if (Array.isArray(value) && Array.isArray(value[0])) return value
  if (Array.isArray(value)) return [value]
  return []
}

// const getMaterialsCategoryParams = (value: any) => {
//   const list = normalizeMaterialsCategory(value)
//
//   const fullySelectedTopList = Array.from(
//     new Set(
//       list
//         .filter((item: any) => Array.isArray(item) && item.length === 1)
//         .map((item: any) => item?.[0])
//         .filter((v: any) => v !== undefined && v !== null && v !== '')
//     )
//   )
//
//   const fullySelectedSet = new Set(fullySelectedTopList.map((v: any) => String(v)))
//   const childCategoryList = Array.from(
//     new Set(
//       list
//         .filter((item: any) => Array.isArray(item) && item.length >= 2)
//         .filter((item: any) => !fullySelectedSet.has(String(item?.[0])))
//         .map((item: any) => item?.[1])
//         .filter((v: any) => v !== undefined && v !== null && v !== '')
//     )
//   )
//
//   const materialsCategory = fullySelectedTopList.join(',')
//   const category = childCategoryList.join(',')
//
//   return {
//     materialsCategoryList: list.length ? list : undefined,
//     materialsCategory: materialsCategory || undefined,
//     category: category || undefined,
//   }
// }

export const Storesearchquery = (props: {
  loading?: any
  filterColumn?: any[]
  filterSelectList?: any[]
  submitPageList?: (v: any) => void
  onValueChange: (queries: storePageParams) => void
  onBatchReportDamaged: () => void
}) => {
  const [form] = Form.useForm()

  const [popoverForm] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const data: any = useSelector(selectDurgsystemData)

  const tenantCategory = useSelector(selectTenantCategory)

  const location: any = useLocation()

  const [treeData, setTreeData] = useState<any>([])

  const dataParams = JSON.parse(
    sessionStorage.getItem(location.pathname) || '{}'
  )

  const [open, setOpen] = useState(false)

  const dateColorList = [
    { name: '已失效', color: '#9564ad' },
    { name: '近1个月', color: '#FF5D5D' },
    { name: '近3个月', color: '#FA8714' },
    { name: '近6个月', color: '#0787F4' },
    { name: '大于6个月', color: '#333333' },
  ]

  useEffect(() => {
    dispatch(pageDurgsystem(1, 100, 1))
    form.setFieldsValue({
      state: 1,
      showFlag: 0,
      mergeFlag: 0,
    })
    popoverForm?.setFieldsValue({
      state: dataParams?.state?.toString() == '0' ? 0 : 1,
      chrgitmLvs: dataParams?.chrgitmLvs,
      anaesthesiaTag: dataParams?.anaesthesiaTag == 1 ? true : false,
      antibioticTag: dataParams?.antibioticTag == 1 ? true : false,
      basicMedicineTag: dataParams?.basicMedicineTag == 1 ? true : false,
      natNegoDrugFlag: dataParams?.natNegoDrugFlag == 1 ? true : false,
      mergeByName: dataParams?.mergeByName == 1 ? true : false,
    }),
      form.submit()
  }, [])

  const getYPFL = () => {
    const data = Materiales.map((v) => {
      return {
        id: v,
        value: v.toString(),
        label: getMaterialsName(v),
        children: [],
      }
    })

    dispatch(
      getCommonCodeCompletionsAsync({
        category: CommonCodeCategory.Durg,
        keyword: '',
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const tree = data.map((v) => {
          if (v.id == 0) {
            return {
              ...v,
              children: res.records.map((el: any) => ({
                value: el.codeName,
                label: el.codeName,
              })),
            }
          } else if (v.id == 1) {
            return {
              ...v,
              children: [
                { value: '材料', label: '材料' },
                { value: '器械', label: '器械' },
                { value: '消耗品', label: '消耗品' },
                { value: '其他', label: '其他' },
              ],
            }
          } else if (v.id == 2) {
            return {
              ...v,
              children: [
                { value: '第一类医疗器械', label: '第一类医疗器械' },
                { value: '第二类医疗器械', label: '第二类医疗器械' },
                { value: '第三类医疗器械', label: '第三类医疗器械' },
              ],
            }
          } else if (v.id == 4) {
            return {
              ...v,
              children: [
                { value: '食品', label: '食品' },
                { value: '化妆品', label: '化妆品' },
                { value: '保健品', label: '保健品' },
                { value: '卫生消毒用品', label: '卫生消毒用品' },
                { value: '初级农产品', label: '初级农产品' },
                { value: '其他产品', label: '其他产品' },
              ],
            }
          } else {
            return v
          }
        })

        setTreeData(tree)
      })
  }
  useEffect(() => {
    getYPFL()
    if (Object.keys(dataParams).length) {
      form.setFieldsValue({
        ...dataParams,
        materialsCategory: dataParams?.materialsCategoryList,
        registrationTimeHead: dataParams?.deadlineStart
          ? moment(dataParams?.deadlineStart).format(DateTimeFormatSimpleOnly)
          : undefined,
        registrationTimeTail: dataParams?.deadlineEnd
          ? moment(dataParams?.deadlineEnd).format(DateTimeFormatSimpleOnly)
          : undefined,
      })
      popoverForm.setFieldsValue({
        ...dataParams,
        state: dataParams?.state?.toString() == '0' ? 0 : 1,
      })
    }
    form.submit()
  }, [])


  const getMaterialsCategoryInfo = (materialsCategoryList:any)=>{
    const materialsCategory = materialsCategoryList?.filter((v:any)=> v?.length == 1)
    const category = materialsCategoryList?.filter((v:any)=> v?.length != 1).map((item: any) => item?.[1])

    return {
      materialsCategory:materialsCategory?.length ? materialsCategory?.join(',') :'',
      category:category?.length ? category?.join(',') :'',
      materialsCategoryList:materialsCategoryList
    }
  }

  const refresh = () => {
    const materialsCategoryList = form.getFieldsValue()?.materialsCategory

    props.onValueChange({
      ...dataParams,
      ...form.getFieldsValue(),
      ...getMaterialsCategoryInfo(materialsCategoryList),
      ...popoverForm.getFieldsValue(),
      chrgitmLvs: popoverForm.getFieldsValue()?.chrgitmLvs
        ? popoverForm.getFieldsValue()?.chrgitmLvs?.join(',')
        : '',
      anaesthesiaTag: popoverForm.getFieldsValue()?.anaesthesiaTag
        ? Number(popoverForm.getFieldsValue()?.anaesthesiaTag)
        : null,
      antibioticTag: popoverForm.getFieldsValue()?.antibioticTag
        ? Number(popoverForm.getFieldsValue()?.antibioticTag)
        : null,
      basicMedicineTag: popoverForm.getFieldsValue()?.basicMedicineTag
        ? Number(popoverForm.getFieldsValue()?.basicMedicineTag)
        : null,
      natNegoDrugFlag: popoverForm.getFieldsValue()?.natNegoDrugFlag
        ? Number(popoverForm.getFieldsValue()?.natNegoDrugFlag)
        : null,
      provinceTendFlag: popoverForm.getFieldsValue()?.provinceTendFlag
        ? Number(popoverForm.getFieldsValue()?.provinceTendFlag)
        : null,
      mergeByName: popoverForm.getFieldsValue()?.mergeByName
        ? Number(popoverForm.getFieldsValue()?.mergeByName)
        : 0,
      current: 1,
    })
  }

  const dropdownRender = useCascaderDropdownRender(
    treeData,
    () => normalizeMaterialsCategory(form.getFieldValue('materialsCategory')),
    (v) => form.setFieldsValue({ materialsCategory: v }),
    refresh,
  )

  return (
    <Form
      form={form}
      name='control-hooks'
      autoComplete='off'
      onFinish={(values: any) => {
        const current = dataParams.current
        const materialsCategoryList = values?.materialsCategory
        props.onValueChange({
          ...dataParams,
          ...values,
          ...getMaterialsCategoryInfo(materialsCategoryList),
          current: current || 1,
        })
      }}
    >
      <Row style={{ margin: '0 0 10px 0' }} justify='space-between'>
        <Space wrap={false}>
          <Form.Item name='name' getValueFromEvent={stringTrim} noStyle>
            <Input
              size='middle'
              placeholder='关键词'
              allowClear
              style={{ width: '10rem' }}
              prefix={<SearchOutlined />}
              onChange={refresh}
            />
          </Form.Item>
          <Form.Item name='storehouseId' noStyle>
            <Select
              allowClear
              placeholder='库房列表'
              dropdownClassName={styles.select}
              showSearch
              onChange={refresh}
              style={{ width: '7rem' }}
              // suffixIcon={<CaretDownFilled />}
              optionFilterProp='children'
            >
              {data.map((v: any, i: any) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='materialsCategory' noStyle>
            <Cascader
                dropdownClassName={styles.cascaderDropdown}
                className={styles.materialsCategoryCascader}
                options={treeData}
                onChange={refresh}
                multiple
                maxTagTextLength={12}
                changeOnSelect
                placeholder='商品类别'
                style={{ width: '7rem' }}
                expandTrigger="hover"
                dropdownRender={dropdownRender}
            />
          </Form.Item>
          <Form.Item name='billingCategory' noStyle>
            <Select
              placeholder='开票项目'
              allowClear
              onChange={refresh}
              dropdownClassName={styles.select}
            // suffixIcon={<CaretDownFilled />}
            >
              {InvoiceBillingCategories.map((v) => {
                return (
                  <Option value={v} key={v}>
                    {BillingCategoryName(v)}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='showFlag' noStyle>
            <Select
              placeholder='零库存'
              allowClear
              onChange={refresh}
              // suffixIcon={<CaretDownFilled />}
              dropdownClassName={styles.select}
              style={{ width: '7rem' }}
            >
              <Option value={0}>零库存-否</Option>
              <Option value={1}>零库存-是</Option>
            </Select>
          </Form.Item>

          <Form.Item name='mergeFlag' noStyle>
            <Select
              placeholder='合并'
              allowClear
              onChange={refresh}
              dropdownClassName={styles.select}
              style={{ width: '7rem' }}
            // suffixIcon={<CaretDownFilled />}
            >
              <Option value={0}>合并-否</Option>
              <Option value={1}>合并-是</Option>
            </Select>
          </Form.Item>

          <DateSelect
            style={{ width: '120px' }}
            placeholder='有效期至'
            allowClear={false}
            labelPrefix=''
            options={StoreSearchRecentTimes}
            namePrefix='registrationTime'
            onChange={refresh}
          />
          {tenantCategory == 17 ? <></> :
            <Popover
              visible={open}
              overlayClassName={styles.formQueryPopover}
              content={
                <>
                  <Form
                    form={popoverForm}
                    onFinish={(val) => {
                      refresh()
                      setOpen(false)
                    }}
                  >
                    <Col span={24} style={{ marginLeft: '10px' }}>
                      <Form.Item label='供应商' name='supplierName'>
                        <Input placeholder='供应商' style={{ width: '200px' }} />
                      </Form.Item>
                    </Col>
                    <Col span={24} style={{ marginLeft: '10px' }}>
                      <Form.Item label='商品名'>
                        <Space align='center'>
                          <Form.Item
                            name='mergeByName'
                            valuePropName='checked'
                            noStyle
                          >
                            <Checkbox>同名合并</Checkbox>
                          </Form.Item>
                          <Popover
                            content={
                              <div>
                                <p>商品名和账簿单位都一致时才会合并查询。</p>
                              </div>
                            }
                            placement='bottom'
                            title='同名合并：'
                            trigger='hover'
                          >
                            <QuestionCircleTwoTone />
                          </Popover>
                        </Space>
                      </Form.Item>
                    </Col>
                    <Col span={24} style={{ marginLeft: '24px' }}>
                      <Form.Item label='等级' name='chrgitmLvs'>
                        <Checkbox.Group>
                          <Checkbox value={'01'}>甲</Checkbox>
                          <Checkbox value={'02'}>乙</Checkbox>
                          <Checkbox value={'03'}>丙</Checkbox>
                        </Checkbox.Group>
                      </Form.Item>
                    </Col>
                    <Row>
                      <Col style={{ margin: '4px 0 0 0 ' }}>药品范围：</Col>
                      <Col span={4}>
                        <Form.Item
                          label=''
                          name='natNegoDrugFlag'
                          valuePropName='checked'
                        >
                          <Checkbox>国谈药</Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Form.Item
                          label=''
                          name='provinceTendFlag'
                          valuePropName='checked'
                        >
                          <Checkbox>省招药</Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Form.Item
                          label=''
                          name='antibioticTag'
                          valuePropName='checked'
                        >
                          <Checkbox>抗生素</Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Form.Item
                          label=''
                          name='basicMedicineTag'
                          valuePropName='checked'
                        >
                          <Checkbox>基药</Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Form.Item
                          label=''
                          name='anaesthesiaTag'
                          valuePropName='checked'
                        >
                          <Checkbox>毒麻类</Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row style={{ marginLeft: '28px' }}>
                      <Form.Item label='状态' name='state'>
                        <Radio.Group
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                          }}
                          defaultValue={1}
                        >
                          <Radio value={0}>停用</Radio>
                          <Radio value={1}>启用</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Row>
                    <Col span={24} style={{ marginLeft: '24px' }}>
                      <Form.Item name='cabineNo' label='柜号'>
                        <Input
                          size='middle'
                          placeholder='柜号'
                          allowClear
                          style={{ width: '200px' }}
                        />
                      </Form.Item>
                    </Col>

                    <Row
                      style={{
                        height: '1px',
                        background: '#f0f0f0',
                        marginTop: '10px',
                      }}
                    ></Row>
                    <Space
                      style={{
                        display: 'flex',
                        justifyContent: 'end',
                        marginTop: '10px',
                      }}
                    >
                      <Button
                        size='middle'
                        type={'ghost'}
                        onClick={() => {
                          setOpen(false)
                        }}
                      >
                        取消
                      </Button>
                      <Button size='middle' type='primary' htmlType='submit'>
                        确定
                      </Button>
                    </Space>
                  </Form>
                </>
              }
              title=''
              trigger='click'
              onVisibleChange={(v) => {
                setOpen(v)
              }}
            >
              <Form.Item name='' initialValue={'筛选'} noStyle>
                <Button
                  style={{
                    color: theme.tc2,
                    width: '78px',
                    textAlign: 'left',
                    // overflow: 'hidden',
                    // textOverflow: 'ellipsis',
                  }}
                  icon={
                    <FilterIconOutlined
                      style={{
                        width: '14px',
                        height: '14px',
                        position: 'relative',
                        top: 2,
                        left: -2,
                        color: '#666',
                      }}
                    />
                  }
                  onClick={() => {
                    setOpen(true)
                  }}
                >
                  筛选
                </Button>
              </Form.Item>
            </Popover>
          }
          <Button
            loading={props?.loading}
            type='primary'
            onClick={() => {
              refresh()
            }}
          >
            查询
          </Button>
          <FilterColumn
            filterColumn={props?.filterColumn}
            filterSelectList={props?.filterSelectList}
            // 筛选列变化时的数据
            onColumnVisibilityChange={(v: any) => {
              // 以 filterColumn 的顺序为基准，用 v 中的字段顺序重排，并保留 filterColumn 的 visible 状态
              const sortList = props?.filterColumn?.map((val: any) => {
                return {
                  ...val,
                  visible: v?.includes(val.field)
                }
              })
              props?.submitPageList && props?.submitPageList(sortList)
            }}
          />
        </Space>
        <Space>
          <Col flex={1} style={{ display: 'flex', justifyContent: 'end' }}>
            <div className={styles.flexbox}>
              {
                dateColorList?.map(v => {
                  return (
                    <div className={styles.flexbox} key={v.name}>
                      <span className={styles.iconItem} style={{ background: v.color }}></span>
                      <span>{v.name}</span>
                    </div>
                  )
                })
              }
            </div>
          </Col>
        </Space>
      </Row>
    </Form>
  )
}
